import { useMutation, useQueryClient } from "@tanstack/react-query";

import { deleteCropExplorationEntriesByYear, deleteCropExplorationTemplateYear } from "services";

import { DELETE_CROP_EXPLORATIONS_YEAR, GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES } from "consts";

export const useDeleteCropExplorationEntriesByYear = (isAdmin: boolean = false) => {
  const queryClient = useQueryClient();
  return useMutation({
    mutationKey: [DELETE_CROP_EXPLORATIONS_YEAR],
    mutationFn: !isAdmin ? deleteCropExplorationEntriesByYear : deleteCropExplorationTemplateYear,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: [GET_CROP_EXPLORATIONS, GET_CROP_EXPLORATION_TEMPLATES] });
    },
  });
};
